import axios from 'axios'

const prodAppId = 'ab19da56-d65e-4989-b94b-10fd2879ba48'
const prodAccessKey = 'V2-SZK2L-ddWcu-q8OQi-q2GlC-cHWOz-OLinm-kewcs-2GqgF'
const appId = process.env.REACT_APP_APPSHEET_APP_ID || prodAppId
const appAccessKey = process.env.REACT_APP_APPSHEET_KEY || prodAccessKey

const appSheetHeaders = {
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    ApplicationAccessKey: appAccessKey
  }
}

const fromAppSheetTable = (tableName) => {
  // return 'api/v2/apps/' + appId + '/tables/' + tableName + '/Action'
  return 'appsheet/table/' + tableName + '/action'
}

export const buildBody = (action, properties = {}, rows = [], data = {}) => {
  return {
    Action: action,
    Properties: {
      Locale: 'en-US',
      Timezone: 'Pacific Standard Time',
      ...properties
    },
    Rows: rows,
    ...data
  }
}

export const postToAppSheet = (tableName, data) => {
  const a = 1
  return axios.post(fromAppSheetTable(tableName), data, appSheetHeaders)
}

export const getMonthEnd = () => {
  const d = new Date()
  d.setHours(0, 0, 0, 0)
  d.setDate(0)
  return d.toISOString()
}
